<template>
  <div>
    <table class="mt-4 bg-card main-table w-100 text-right">
      <tr class="text-break">
        <td class="pl-4 text-left text-middle-bond" style="width: 20%" >
          Type Trace Address
        </td>
        <td class="text-left text-middle-bond" style="width: 17%" >
          From
        </td>
        <td class="text-left text-middle-bond" style="width: 20%" >
          To
        </td>
        <td class="text-left text-middle-bond" style="width: 17%" >
          Value
        </td>
        <td class="text-left text-middle-bond" style="width: 17%" >
          Gas Limit
        </td>


      </tr>
      <tr v-for="(item,index) in data_onshow" :key="index" class="hover-bg transTable">
        <td class="mb-none text-left d-flex flex-row align-items-center">
          <div class="ml-4 trans-icon" style="width: 42px;height: 42px">
            <div class="token-icon-img"></div>
          </div>
          <div class="text-left ml-3">
            {{item.type}}
          </div>
        </td>
        <td class="text-left">
          <div class="trans-td-text trans-from-text">
            <router-link :to="`/address/${item.from}`">{{getSortAddress(item.from)}}</router-link>
            <img src="../../images/transtion/arrow-right.png"/>
          </div>
        </td>
        <td class="text-left">
          <div class="trans-td-text">
            <router-link v-if="item.contract" :to="`/address/${item.contract}`">
              {{getSortAddress(item.contract)}}
            </router-link>
            <router-link v-else :to="`/address/${item.to}`">
              {{getSortAddress(item.to)}}
            </router-link>
          </div>
        </td>
        <td class="text-left">
          <div class="trans-td-text">{{parseValue(item.value)}} MAPO</div>
        </td>
        <td class="text-left">
          <div class="trans-td-text">{{parseFloat(parseBig(item.gas))}}</div>
        </td>

      </tr>
    </table>
  </div>
</template>

<script>
import {getSortAddress, parseBalance, parseBigInter} from '@/util/index'
export default {
  name: 'internalTxnsTable',
  components: {},
  props: [
    'data',
    'cfg',
    'page'
  ],
  data() {
    return {
      showImg:0,
      type: null,
      showRecordPage:false,//显示数据tab
      nowRecordPage:25,//当前显示数据
      recordPage:[
        {num:25},
        {num:50},
        {num:75},
        {num:100}
      ],//一页多少数据
      cfg_pagination: {
        'page_size': 25, //每页条目数量
        'page_current': 1, // 当前页
        'count_items': 0, //总个数，和总页数选填其一
        'btn_num': 5, // 按钮个数
        'turnpage_top': true, // 翻页时操作滚动置顶
        'count_pages':0, //总页数，和个页数选填其一 // 默认请给 0 值-便于首次加载时不露出分页器
      },
      data_onshow: [
        {}
      ],

      contract:'',
      bykey:'',
      pairlist:''
    }
  },
  computed: {},
  watch: {},
  methods: {
    parseBig(val){
      return parseBigInter(val)
    },
    parseValue (input) {
      if(!input){
        return '0'
      }
      const { i, d } = parseBalance(input)
      if (i === '0' && d.slice(1, 4) === '000') {
        if (d === ',000,000,000,000,000,000') {
          return '0'
        } else {
          return '< 0.001'
        }
      }
      return `${i}.${d.slice(1, 4)}`
    },
    getSortAddress(val){
      return getSortAddress(val)
    },
    //选择当前一页多少数据
    actionSelectPage(item) {
      let v = this
      v.nowRecordPage=item.num
      v.cfg_pagination.page_size=item.num
      v.showRecordPage=false
      // console.log(v.showRecordPage)
      v.initData()
    },
    initData(){
      let v = this
      if(!v.data)return

      v.cfg_pagination.page_current = 1

      // 计算页码
      v.cfg_pagination.count_pages = Math.ceil(v.data.length/v.cfg_pagination.page_size)

      // 过滤数据
      v.getList()
    },

    getList(){
      let v = this
      // 过滤条目
      let start = (v.cfg_pagination.page_current -1) * v.cfg_pagination.page_size
      let end = v.cfg_pagination.page_current * v.cfg_pagination.page_size
      v.data_onshow = v.data.slice(start, end)
      // console.log(v.data_onshow)
    },
  },
  created() {
    this.initData()
  },
  mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
.token-icon-img {
  width: 25px;
  height: 20px;
  background: url("../../images/token/account-black.png")no-repeat;
  background-size: 100% auto;
}


</style>
